import { Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Wrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '24px',
}));

export const Label = styled('span')(() => ({
  fontSize: '13px',
  fontWeight: 600,
  color: protoColors.textMuted,
  whiteSpace: 'nowrap',
}));

export const Select = styled(TextField)(() => ({
  minWidth: '260px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: protoColors.surface,
    fontSize: '14px',
    fontWeight: 600,
    color: protoColors.textPrimary,
    '& fieldset': {
      borderColor: protoColors.border,
    },
    '&:hover fieldset': {
      borderColor: protoColors.purple,
    },
    '&.Mui-focused fieldset': {
      borderColor: protoColors.purple,
    },
  },
}));
